// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_o8-0";
export var discountCodeInput = "_o8-1";